import { Box, Dialog, IconButton, Theme, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ExcludedSecurityObj } from "../../../redux-store/types/onBoarding";
import SecurityInclusionTable from "./SecurityInclusionTable";

interface IncludedSecuritiesPopupProps {
    open: boolean;
    onClose: () => void;
    includedSecuritiesTableData: Array<ExcludedSecurityObj & { isExcluded: boolean; }>;
}

export default function IncludedSecuritiesPopup({
    open,
    onClose,
    includedSecuritiesTableData,
}: IncludedSecuritiesPopupProps): JSX.Element {
    const theme = useTheme()

    return (
        <Dialog
            onClose={onClose}
            open={open}
            maxWidth="md"
            fullWidth
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    backgroundColor: theme.palette.common.white,
                    padding: { xs: "20px 15px 10px 15px", sm: "25px 30px 15px 30px" },
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    maxHeight: "80%",
                    minHeight: "200px"
                },
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <Typography
                    variant="h2"
                    sx={{ color: theme.palette.text.primary }}
                >
                    Included Securities
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon sx={{ color: theme.palette.text.primary }} />
                </IconButton>
            </Box>
            <SecurityInclusionTable tableData={includedSecuritiesTableData} />
        </Dialog>
    )
}
